// import { DEAL_LENGTH_MIN_IN_MS, DEAL_START_MIN_OFFSET_FROM_NOW_IN_MS } from '../../../const/deal';
import { CatalogItemScheduleViewModel } from '../../../model/catalog/item/schedule/view';
import { DayOfWeek } from '../../../model/dayOfWeek';

export const hasIntervalsForToday = (schedule: CatalogItemScheduleViewModel | undefined): boolean => {
  const now = new Date();

  return schedule
    ? schedule.intervals.some((interval) => {
        if (interval.dayOfWeek !== (now.getDay() as DayOfWeek)) {
          return false;
        }

        // Uncomment to use date adjusted with deal related time constants
        const targetDate = new Date(); // new Date(now.getMilliseconds() + DEAL_START_MIN_OFFSET_FROM_NOW_IN_MS + DEAL_LENGTH_MIN_IN_MS);

        const intervalEndDate = new Date(now);
        const [hours, minutes] = interval.to.split(':').map((v) => parseInt(v));

        intervalEndDate.setHours(hours ? hours : 23, minutes);

        if (!hours) {
          intervalEndDate.setMilliseconds(intervalEndDate.getMilliseconds() + 60 * 60 * 1000);
        }

        return targetDate < intervalEndDate;
      })
    : false;
};
